// ─────────────────────────────────────────────
// Games Page JavaScript
// ─────────────────────────────────────────────

import './index.scss';

// Set current year in footer
const yearElement = document.getElementById('current-year');
if (yearElement) {
    yearElement.textContent = new Date().getFullYear().toString();
}

// Smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (this: HTMLAnchorElement, e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href') || '');
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Image fullscreen modal functionality
document.addEventListener('DOMContentLoaded', function() {
    // Create fullscreen overlay
    const fullscreenOverlay = document.createElement('div');
    fullscreenOverlay.className = 'image-fullscreen';
    fullscreenOverlay.innerHTML = '<button class="image-fullscreen-close" aria-label="Close">×</button>';
    const fullscreenImg = document.createElement('img');
    fullscreenOverlay.appendChild(fullscreenImg);
    document.body.appendChild(fullscreenOverlay);

    // Find all images and wrap them in containers if not already wrapped
    const images = document.querySelectorAll('img:not(.image-fullscreen img):not(.games-page-bg):not(.page-hero-bg):not(.games-cta-bg):not(.footer-image):not(.showcase-logo)');
    images.forEach(img => {
        if (!img.closest('.image-container') && !img.closest('.logo') && !img.classList.contains('showcase-logo')) {
            const container = document.createElement('div');
            container.className = 'image-container';
            img.parentNode?.insertBefore(container, img);
            container.appendChild(img);
        }
    });

    // Add click handlers to image containers
    document.querySelectorAll('.image-container').forEach(container => {
        container.addEventListener('click', function(this: HTMLElement) {
            const img = this.querySelector('img');
            if (img) {
                fullscreenImg.src = img.src;
                fullscreenImg.alt = img.alt || '';
                fullscreenOverlay.classList.add('active');
                document.body.style.overflow = 'hidden';
            }
        });
    });

    // Close fullscreen handlers
    function closeFullscreen() {
        fullscreenOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    const closeButton = fullscreenOverlay.querySelector('.image-fullscreen-close');
    if (closeButton) {
        closeButton.addEventListener('click', closeFullscreen);
    }
    
    fullscreenOverlay.addEventListener('click', function(e) {
        if (e.target === fullscreenOverlay) {
            closeFullscreen();
        }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && fullscreenOverlay.classList.contains('active')) {
            closeFullscreen();
        }
    });
});

